// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const warBanner = defineModel({
  id: "war-banner",
  batchId: "future",
  name: "War banner",
  tags: ["scenery","war","banner","low-poly","age-of-mcp","future","military"],
  summary: "A war banner — a rallying standard marking a muster or camp.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.22,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.12, 0.16, 0.08, 9), color: "#6b5436", position: [0, 0.04, 0] },
      { geometry: new THREE.CylinderGeometry(0.02, 0.025, 1.1, 6), color: "#6f4a26", position: [0, 0.63, 0] },
      { geometry: new THREE.ConeGeometry(0.035, 0.14, 5), color: "#9aa0a6", position: [0, 1.25, 0] },
      { geometry: new THREE.BoxGeometry(0.04, 0.025, 0.3), color: "#6f4a26", position: [0, 1.12, 0.13] },
      { geometry: new THREE.BoxGeometry(0.015, 0.5, 0.26), color: "#9d3530", position: [0, 0.92, 0.24] },
      { geometry: new THREE.BoxGeometry(0.012, 0.5, 0.06), color: "#7e2925", position: [0.006, 0.92, 0.12] },
      { geometry: new THREE.ConeGeometry(0.13, 0.16, 3), color: "#9d3530", position: [0, 0.65, 0.24], rotation: [1.570796, 0, 0], scale: [1, 1, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.005, 0.005, 0.5, 4), color: "#b8a479", position: [-0.12, 0.28, -0.04], rotation: [0, 0, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.005, 0.005, 0.5, 4), color: "#b8a479", position: [0.12, 0.28, -0.04], rotation: [0, 0, -0.5] },
    ] },
    { id: "variant-1", label: "Variant 2", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.12, 0.16, 0.08, 9), color: "#6b5436", position: [0, 0.04, 0] },
      { geometry: new THREE.CylinderGeometry(0.02, 0.025, 1.1, 6), color: "#6f4a26", position: [0, 0.63, 0] },
      { geometry: new THREE.ConeGeometry(0.035, 0.14, 5), color: "#9aa0a6", position: [0, 1.25, 0] },
      { geometry: new THREE.BoxGeometry(0.04, 0.025, 0.3), color: "#6f4a26", position: [0, 1.12, 0.13] },
      { geometry: new THREE.BoxGeometry(0.015, 0.5, 0.26), color: "#33558a", position: [0, 0.92, 0.24] },
      { geometry: new THREE.BoxGeometry(0.012, 0.5, 0.06), color: "#284572", position: [0.006, 0.92, 0.12] },
      { geometry: new THREE.ConeGeometry(0.13, 0.16, 3), color: "#33558a", position: [0, 0.65, 0.24], rotation: [1.570796, 0, 0], scale: [1, 1, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.005, 0.005, 0.5, 4), color: "#b8a479", position: [-0.12, 0.28, -0.04], rotation: [0, 0, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.005, 0.005, 0.5, 4), color: "#b8a479", position: [0.12, 0.28, -0.04], rotation: [0, 0, -0.5] },
    ] },
    { id: "variant-2", label: "Variant 3", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.12, 0.16, 0.08, 9), color: "#6b5436", position: [0, 0.04, 0] },
      { geometry: new THREE.CylinderGeometry(0.02, 0.025, 1.1, 6), color: "#6f4a26", position: [0, 0.63, 0] },
      { geometry: new THREE.ConeGeometry(0.035, 0.14, 5), color: "#9aa0a6", position: [0, 1.25, 0] },
      { geometry: new THREE.BoxGeometry(0.04, 0.025, 0.3), color: "#6f4a26", position: [0, 1.12, 0.13] },
      { geometry: new THREE.BoxGeometry(0.015, 0.5, 0.26), color: "#c79a3a", position: [0, 0.92, 0.24] },
      { geometry: new THREE.BoxGeometry(0.012, 0.5, 0.06), color: "#a87f28", position: [0.006, 0.92, 0.12] },
      { geometry: new THREE.ConeGeometry(0.13, 0.16, 3), color: "#c79a3a", position: [0, 0.65, 0.24], rotation: [1.570796, 0, 0], scale: [1, 1, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.005, 0.005, 0.5, 4), color: "#b8a479", position: [-0.12, 0.28, -0.04], rotation: [0, 0, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.005, 0.005, 0.5, 4), color: "#b8a479", position: [0.12, 0.28, -0.04], rotation: [0, 0, -0.5] },
    ] },
  ],
  animations: [],
});
